import { render, staticRenderFns } from "./TeamMemberList.vue?vue&type=template&id=a0f9c438&scoped=true&"
import script from "./TeamMemberList.vue?vue&type=script&lang=js&"
export * from "./TeamMemberList.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberList.vue?vue&type=style&index=0&id=a0f9c438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f9c438",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TeamMemberList.vue
// module id = 185
// module chunks = 0